export const bucketName = "freelanceryyg";
export const apiHost = "https://jxapi.yygapp.com/api/";
export const ossHost = "https://freelanceryyg.oss-cn-beijing.aliyuncs.com/";